import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import { formatQueryParams } from "helpers/format";
import timeWorkingApi from "api/timeWorkingApi";

export const getTimeWorking = createAsyncThunk("TimeWorking" , async (params: any = {}) => {
  try{
    const response = await timeWorkingApi.getTimeWorking(formatQueryParams(params))
    return response;
  }catch (error) {
    return error;
  }
});

export const getTimeWorkingList = async (params: any = {}) => {
  try{
    const response = await timeWorkingApi.getTimeWorking(params)
    return response;
  }catch (error) {
    return error;
  }
};

export const postTimeWorking = async (data: any = {}) => {
  try{
    const response = await timeWorkingApi.postTimeWorking(data);
    return response;
  }catch (error) {
    return error;
  }
};

export const putTimeWorking = async (data: any = {}) => {
  try{
    const response = await timeWorkingApi.putTimeWorking(data);
    return response;
  }catch (error) {
    return error;
  }
};


